var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 228,
    viewBox: "0 0 236 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.995 188.668L75.6481 214.054C72.3301 216.048 68.5323 217.101 64.6615 217.101C60.7907 217.101 56.9928 216.048 53.6748 214.054L21.6748 194.854C18.5255 192.962 15.9183 190.289 14.1056 187.093C12.2929 183.898 11.3362 180.288 11.3281 176.614V142.054C11.3362 138.38 12.2929 134.771 14.1056 131.575C15.9183 128.38 18.5255 125.706 21.6748 123.814L64.6615 98.001L117.995 130.001M117.995 188.668V130.001M117.995 188.668L160.341 214.054C163.659 216.048 167.457 217.101 171.328 217.101C175.199 217.101 178.997 216.048 182.315 214.054L214.315 194.854C217.464 192.962 220.071 190.289 221.884 187.093C223.697 183.898 224.653 180.288 224.661 176.614V142.054C224.653 138.38 223.697 134.771 221.884 131.575C220.071 128.38 217.464 125.706 214.315 123.814L171.328 98.001L117.995 130.001M117.995 130.001L64.6615 162.001M117.995 130.001L171.328 162.001M64.6615 162.001L14.1015 131.601M64.6615 162.001V217.148M171.328 162.001L221.888 131.601M171.328 162.001V217.148",
    stroke: "#D4582A",
    strokeWidth: 21.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.997 129.996L64.6641 97.9964V51.3831C64.6721 47.7092 65.6288 44.0996 67.4415 40.904C69.2542 37.7084 71.8615 35.0352 75.0107 33.1431L107.011 13.9431C110.329 11.9496 114.127 10.8965 117.997 10.8965C121.868 10.8965 125.666 11.9496 128.984 13.9431L160.984 33.1431C164.133 35.0352 166.741 37.7084 168.553 40.904C170.366 44.0996 171.323 47.7092 171.331 51.3831V97.9964L117.997 129.996ZM117.997 129.996V71.3298M117.997 71.3298L67.4374 40.9298M117.997 71.3298L168.557 40.9298",
    stroke: "#D4582A",
    strokeWidth: 21.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/Model.38a9ff7950c679e9dbd742ef4b60eeec.svg";
export { ForwardRef as ReactComponent };